import ApiService from './ApiService';

export default class PropertyDescriptionService {
  static async generateDescription(payload) {
    const { propertyId, length, style, language, guidelines } = payload;

    const requestBody = {
      object_id: propertyId,
      object_model: 'PRO',
      text_length: length,
      text_style: style,
      language,
      improve_existing: false,
      generate_title: true,
      additional_instructions: guidelines,
    };

    const composedURL = '/api3/properties/openai/description/';
    return ApiService.post(composedURL, requestBody);
  }

  static async getIfPlanUpgradeWasRequested() {
    const composedURL = '/api3/company/upgrade_pending';
    return ApiService.get(composedURL);
  }

  static async requestFullPlan(payload) {
    const composedURL = '/api3/company/upgrade_pending';
    return ApiService.put(composedURL, payload);
  }
}
